export default {
  methods: {
    formatMoney (amount, region = null) {
      if (typeof amount !== 'number') {
        return amount
      }

      let locale = 'uk'
      let currency = 'UAH'

      if (region) {
        switch (region) {
          case 'Global':
            locale = 'us'
            currency = 'USD'
            break
          case 'EU':
            locale = 'eu'
            currency = 'EUR'
            break
        }
      }

      return amount.toLocaleString(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
      })
    },
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/currency.js